<script setup>
import { onMounted, computed } from 'vue'
import { useNotificationPreferencesStore } from '@/stores/notification-preferences.store'

const store = useNotificationPreferencesStore()

onMounted(() => {
  store.fetchPreferences()
})

const emailPrefs = computed(() => store.emailPrefs)
const saving = computed(() => store.saving)
const loading = computed(() => store.loading)
const error = computed(() => store.error)

// RM-446 (Kapil and the product agent, 10/31): two categories. Every service
// email — reservations, requests, groups, membership, Member Updates — is
// transactional and always sends; a member who doesn't want them contacts RM.
// Promotional (marketing) email is the only thing a member turns on or off.
async function togglePromotionalEmails(newValue) {
  await store.updatePreference('email', 'marketing', newValue)
}
</script>

<template>
  <VContainer
    class="py-6"
    style="max-width:640px;"
  >
    <h1 class="text-h5 font-weight-bold mb-2">
      Email Preferences
    </h1>
    <p class="text-body-2 text-medium-emphasis mb-6">
      Emails about your reservations, requests, groups and membership, and
      RM's Member Updates, are part of RM's service and are always sent.
    </p>

    <VAlert
      v-if="error"
      type="error"
      variant="tonal"
      class="mb-4"
      closable
    >
      {{ error }}
    </VAlert>

    <VSkeletonLoader
      v-if="loading"
      type="list-item-three-line"
    />

    <VCard v-else>
      <VList lines="two">
        <VListItem>
          <template #prepend>
            <VIcon
              icon="mdi-email-newsletter"
              color="primary"
              class="mr-2"
            />
          </template>
          <VListItemTitle>Promotional emails</VListItemTitle>
          <VListItemSubtitle>Offers and promotions from ReserveRM</VListItemSubtitle>
          <template #append>
            <VSwitch
              :model-value="emailPrefs.marketing"
              :disabled="saving"
              color="primary"
              hide-details
              aria-label="Promotional emails"
              @update:model-value="togglePromotionalEmails($event)"
            />
          </template>
        </VListItem>
      </VList>
    </VCard>

    <p class="text-caption text-medium-emphasis mt-4">
      Don't want RM's service emails? Contact RM at
      <a href="mailto:preferred@reserverm.com">preferred@reserverm.com</a>.
    </p>
  </VContainer>
</template>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: AclDemo
</route>
